var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgCalendarIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group 1064"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle 271",
    x: 1,
    y: 3.39999,
    width: 18,
    height: 15.6,
    rx: 1,
    stroke: "#0058A9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 140",
    x1: 5.1001,
    y1: 7,
    x2: 5.1001,
    y2: 19,
    stroke: "#0058A9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 141",
    x1: 9.8999,
    y1: 7,
    x2: 9.8999,
    y2: 19,
    stroke: "#0058A9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 142",
    x1: 14.7,
    y1: 7,
    x2: 14.7,
    y2: 19,
    stroke: "#0058A9"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 145",
    d: "M14.2 1L14.2 4.6",
    stroke: "#0058A9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Line 146",
    d: "M5.80005 1L5.80005 4.6",
    stroke: "#0058A9",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 143",
    x1: 19,
    y1: 7.5,
    x2: 1,
    y2: 7.5,
    stroke: "#0058A9"
  }), /*#__PURE__*/React.createElement("line", {
    id: "Line 144",
    x1: 19,
    y1: 13.5,
    x2: 1,
    y2: 13.5,
    stroke: "#0058A9"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendarIcon);
export default __webpack_public_path__ + "static/media/calendar-icon.495916da5fd5b26ce5e73b024fea1432.svg";
export { ForwardRef as ReactComponent };